export default "<div class=\"diagram\">\n</div>";